import React from 'react';

import { BaseApprovalAlert } from './BaseApprovalAlert';

export const OtherApprovalRequested: React.FC = () => {
  return (
    <BaseApprovalAlert
      heading='Study approval pending'
      message='This study is pending approval from an account admin.'
    />
  );
};
